import { gql } from '@/__generated__/gql';

export const OPEN_OPPORTUNITIES_QUERY = gql(`
  query FatDealCatalogPageOpenOpportunities(
    $page: Int
    $rowsPerPage: Int
    $assetClassQuickFilter: String
    $sort: String
    $order: String
    $search: String
    $statusFilter: [String!]
  ) {
    OpenOpportunities(
      page: $page
      rowsPerPage: $rowsPerPage
      assetClassQuickFilter: $assetClassQuickFilter
      sort: $sort
      order: $order
      search: $search
      statusFilter: $statusFilter
    ) {
      total
      page
      perPage
      filters {
        name
        type
        value
        enabled
        count
      }
      data {
        id
        type
        assetClass {
          id
          name
        }
        subAssetClass {
          id
          name
        }
        subAssetClasses
        securityStatus
        nextClose
        finalClose
        investorDocsDue
        name
        aggregateCommitment
        openedAt
        workflowTransitionTasksHistory {
          id
          taskId
          createdAt
        }
      }
    }
  }
`);

export const INVESTMENTS_BY_WORKFLOW_STATE_QUERY = gql(`
  query FatDealCatalogPageInvestmentsByWorkflowState($data: InvestmentsByWorkflowStateInput!) {
    InvestmentsByWorkflowState(data: $data) {
      total
      page
      lastPage
      perPage
      filters {
        type
        name
        value
        enabled
        count
      }
      data {
        investment {
          id
          name
          type
          symbol
          assetClass {
            id
            name
          }
          subAssetClass {
            id
            name
          }
          subAssetClasses
          finalClose
          investorDocsDue
          securityStatus
          createdAt
          workflowTransitionTasksHistory {
            id
            createdAt
          }
        }
        totalInvestmentAmount
        investorInterests {
          id
          amount
          exempt
          legal_entity {
            id
            entityName
          }
        }
        investorInterestsExempt {
          id
          amount
          exempt
          legal_entity {
            id
            entityName
          }
        }
        investorInterestsTaxable {
          id
          amount
          exempt
          legal_entity {
            id
            entityName
          }
        }
      }
    }
  }
`);

export const CREATE_INVESTOR_INTERESTS_MUTATION = gql(`
  mutation FatDealCatalogPageCreateInvestorInterests($data: [CreateInvestorInterestDto!]!) {
    createInvestorInterests(data: $data) {
      id
    }
  }
`);

export const UPDATE_INVESTOR_INTEREST_AMOUNT_MUTATION = gql(`
  mutation FatDealCatalogPageUpdateInvestorInterestAmount($data: [UpdateInvestorInterestDto!]!) {
    updateInvestorInterestAmount(data: $data) {
      id
    }
  }
`);

export const DELETE_INVESTOR_INTEREST_AMOUNT_MUTATION = gql(`
  mutation FatDealCatalogPageDeleteInvestorInterestAmount($ids: [String!]!) {
    deleteInvestorInterestAmount(ids: $ids)
  }
`);
